import { Component } from '@angular/core';
@Component({
  selector: 'form-editor-navigation-side-bar',
  templateUrl: './navigation-side-bar.component.html',
  styleUrls: ['./navigation-side-bar.component.css']
})
export class NavigationSideBarComponent {}
